<template>
    <div class="subAccount padding-20 bgc box-shadow">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'subAccount',
    data() {
        return {
        }
    },
    methods: {
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.subAccount {
}
</style>
